import React from 'react'

function Loading() {
  return (
    <div className='container justify-content-center'>
        <p>Loading ...</p>
    </div>
  )
}

export default Loading